import {
  EVENTS_ADD_NEW_EVENT,
  EVENTS_GET_ALL_EVENT,
  EVENTS_UPDATE_EVENT,
  EVENTS_DELETE_EVENT,
  EVENTS_UPDATE_USSD_ID,
  EVENTS_GET_EVENT_BY_TYPE,
  EVENTS_GET_TICKET_DETAILS,
  EVENTS_APPROVE_TICKET,
  EVENTS_SEARCH_TICKET,
  EVENTS_GET_ALL_PRE_SELL_TICKETS,
  EVENTS_DELETE_PRE_SELL_TICKET,
  EVENTS_DOWNLOAD_PRE_SELL_TICKET,
  EVENTS_ACTIVATE_TICKET,
  EVENTS_DOWNLOAD_INVITATION_TICKET,
  EVENTS_TOGGLE_PRE_SELL_TICKET_STATUS,
  EVENTS_GET_ALL_INVITATION_TICKETS,
  EVENTS_DELETE_INVITATION_BATCH,
  EVENTS_TOGGLE_INVITATION_BATCH_STATUS,
  EVENTS_DOWNLOAD_INVITATION_BATCH,
  EVENTS_DELETE_INVITATION_TICKET,
  EVENTS_DELETE_MULTIPLE_INVITATION_TICKETS,
  EVENTS_GET_BOOKING_FORM_DATA,
  EVENTS_DELETE_EVENT_TICKET,
  EVENTS_RESEND_TICKET_SMS,
  EVENTS_DELETE_BOOKING
} from '../actions/events'

import {
  API_BASE_URL,
  API_NODE_BASE_URL,
  EVENTS_ADD_NEW_EVENT_URL,
  EVENTS_DELETE_EVENT_URL,
  EVENTS_GET_ALL_EVENTS_URL,
  EVENTS_UPDATE_EVENT_URL,
  EVENTS_UPDATE_USSD_ID_URL,
  EVENTS_GET_EVENTS_BY_TYPE_URL,
  EVENTS_GET_TICKET_DETAILS_URL,
  EVENTS_APPROVE_TICKET_URL,
  EVENTS_SEARCH_TICKET_URL,
  EVENTS_GET_BOOKING_FORM_DATA_URL,
  EVENTS_GET_ALL_PRE_SELL_TICKETS_URL,
  EVENTS_DELETE_PRE_SELL_TICKET_URL,
  EVENTS_DOWNLOAD_PRE_SELL_TICKET_URL,
  EVENTS_ACTIVATE_TICKET_URL,
  EVENTS_DOWNLOAD_INVITATION_TICKET_URL,
  EVENTS_GET_ALL_INVITATION_TICKETS_URL,
  EVENTS_DELETE_INVITATION_BATCH_URL,
  EVENTS_TOGGLE_INVITATION_BATCH_STATUS_URL,
  EVENTS_DOWNLOAD_INVITATION_BATCH_URL,
  EVENTS_TOGGLE_PRE_SELL_TICKET_STATUS_URL,
  EVENTS_DELETE_INVITATION_TICKET_URL,
  EVENTS_DELETE_MULTIPLE_INVITATION_TICKETS_URL,
  EVENTS_DELETE_EVENT_TICKET_URL,
  EVENTS_RESEND_TICKET_SMS_URL,
  EVENTS_DELETE_BOOKING_URL
} from "../variables"

import axios from 'axios'

const state = {};
const mutations = {};
const getters = {};
const actions = {
  [EVENTS_TOGGLE_PRE_SELL_TICKET_STATUS]: ({ commit, state, getters }, payload) => {
    return axios({
      url: API_BASE_URL + EVENTS_TOGGLE_PRE_SELL_TICKET_STATUS_URL,
      method: "POST",
      data: payload,
      headers: {
        'Authorization': 'Bearer ' + getters.getUserAccessToken
      }
    })
  },
  [EVENTS_ACTIVATE_TICKET]: ({ commit, state, getters }, payload) => {
    return axios({
      url: API_BASE_URL + EVENTS_ACTIVATE_TICKET_URL,
      method: "POST",
      data: payload,
      headers: {
        'Authorization': 'Bearer ' + getters.getUserAccessToken
      }
    })
  },
  [EVENTS_DOWNLOAD_INVITATION_TICKET]: ({ commit, state, getters }, payload) => {
    return axios({
      url: API_NODE_BASE_URL + EVENTS_DOWNLOAD_INVITATION_TICKET_URL,
      method: "POST",
      data: payload,
      headers: {
        'Authorization': 'Bearer ' + getters.getUserAccessToken
      },
      responseType: 'blob',
    })
  },
  [EVENTS_DOWNLOAD_PRE_SELL_TICKET]: ({ commit, state, getters }, payload) => {
    return axios({
      url: API_NODE_BASE_URL + EVENTS_DOWNLOAD_PRE_SELL_TICKET_URL,
      method: "POST",
      data: payload,
      headers: {
        'Authorization': 'Bearer ' + getters.getUserAccessToken
      }
    })
  },
  [EVENTS_DELETE_PRE_SELL_TICKET]: ({ commit, state, getters }, payload) => {
    return axios({
      url: API_BASE_URL + EVENTS_DELETE_PRE_SELL_TICKET_URL,
      method: "POST",
      data: payload,
      headers: {
        'Authorization': 'Bearer ' + getters.getUserAccessToken
      }
    })
  },
  [EVENTS_GET_ALL_PRE_SELL_TICKETS]: ({ commit, state, getters }, payload) => {
    return axios({
      url: API_BASE_URL + EVENTS_GET_ALL_PRE_SELL_TICKETS_URL,
      method: "POST",
      data: payload,
      headers: {
        'Authorization': 'Bearer ' + getters.getUserAccessToken
      }
    })
  },
  [EVENTS_SEARCH_TICKET]: ({ commit, state, getters }, payload) => {
    return axios({
      url: API_BASE_URL + EVENTS_SEARCH_TICKET_URL,
      method: "POST",
      data: payload,
      headers: {
        'Authorization': 'Bearer ' + getters.getUserAccessToken
      }
    })
  },
  [EVENTS_APPROVE_TICKET]: ({ commit, state, getters }, payload) => {
    return axios({
      url: API_BASE_URL + EVENTS_APPROVE_TICKET_URL,
      method: "POST",
      data: payload,
      headers: {
        'Authorization': 'Bearer ' + getters.getUserAccessToken
      }
    })
  },
  [EVENTS_GET_TICKET_DETAILS]: ({ commit, state, getters }, payload) => {
    return axios({
      url: API_BASE_URL + EVENTS_GET_TICKET_DETAILS_URL,
      method: "POST",
      data: payload,
      headers: {
        'Authorization': 'Bearer ' + getters.getUserAccessToken
      }
    })
  },
  [EVENTS_GET_ALL_EVENT]: ({ commit, state, getters }, payload) => {
    return axios({
      url: API_BASE_URL + EVENTS_GET_ALL_EVENTS_URL,
      method: "GET",
      params: payload || {},
      headers: {
        'Authorization': 'Bearer ' + getters.getUserAccessToken
      }
    })
  },
  [EVENTS_ADD_NEW_EVENT]: ({ commit, state, getters }, payload) => {
    return axios({
      url: API_BASE_URL + EVENTS_ADD_NEW_EVENT_URL,
      method: 'POST',
      data: payload,
      headers: {
        'Authorization': 'Bearer ' + getters.getUserAccessToken
      }
    })
  },
  [EVENTS_UPDATE_EVENT]: ({ commit, state, getters }, payload) => {
    return axios({
      url: API_BASE_URL + EVENTS_UPDATE_EVENT_URL + payload.id,
      method: 'PUT',
      data: payload,
      headers: {
        'Authorization': 'Bearer ' + getters.getUserAccessToken
      }
    })
  },
  [EVENTS_DELETE_EVENT]: ({ commit, state, getters }, payload) => {
    return axios({
      url: API_BASE_URL + EVENTS_DELETE_EVENT_URL + payload.id,
      method: 'DELETE',
      params: payload.user_id ? { user_id: payload.user_id } : {},
      headers: {
        'Authorization': 'Bearer ' + getters.getUserAccessToken
      }
    })
  },
  [EVENTS_UPDATE_USSD_ID]: ({ commit, state, getters }, payload) => {
    return axios({
      url: API_BASE_URL + EVENTS_UPDATE_USSD_ID_URL,
      method: 'POST',
      data: payload,
      headers: {
        'Authorization': 'Bearer ' + getters.getUserAccessToken
      }
    })
  },
  [EVENTS_GET_EVENT_BY_TYPE]: ({ commit, state, getters }, payload) => {
    return axios({
      url: API_BASE_URL + EVENTS_GET_EVENTS_BY_TYPE_URL,
      method: 'POST',
      data: payload,
      headers: {
        'Authorization': 'Bearer ' + getters.getUserAccessToken
      }
    })
  },
  [EVENTS_DELETE_INVITATION_TICKET]: ({ commit, state, getters }, payload) => {
    return axios({
      url: API_BASE_URL + EVENTS_DELETE_INVITATION_TICKET_URL,
      method: 'POST',
      data: payload,
      headers: {
        'Authorization': 'Bearer ' + getters.getUserAccessToken
      }
    })
  },
  [EVENTS_DELETE_MULTIPLE_INVITATION_TICKETS]: ({ commit, state, getters }, payload) => {
    return axios({
      url: API_BASE_URL + EVENTS_DELETE_MULTIPLE_INVITATION_TICKETS_URL,
      method: 'POST',
      data: payload,
      headers: {
        'Authorization': 'Bearer ' + getters.getUserAccessToken
      }
    })
  },
  [EVENTS_GET_ALL_INVITATION_TICKETS]: ({ commit, state, getters }, payload) => {
    return axios({
      url: API_BASE_URL + EVENTS_GET_ALL_INVITATION_TICKETS_URL,
      method: "POST",
      data: payload,
      headers: {
        'Authorization': 'Bearer ' + getters.getUserAccessToken
      }
    })
  },
  [EVENTS_DELETE_INVITATION_BATCH]: ({ commit, state, getters }, payload) => {
    return axios({
      url: API_BASE_URL + EVENTS_DELETE_INVITATION_BATCH_URL,
      method: "POST",
      data: payload,
      headers: {
        'Authorization': 'Bearer ' + getters.getUserAccessToken
      }
    })
  },
  [EVENTS_TOGGLE_INVITATION_BATCH_STATUS]: ({ commit, state, getters }, payload) => {
    return axios({
      url: API_BASE_URL + EVENTS_TOGGLE_INVITATION_BATCH_STATUS_URL,
      method: "POST",
      data: payload,
      headers: {
        'Authorization': 'Bearer ' + getters.getUserAccessToken
      }
    })
  },
  [EVENTS_DOWNLOAD_INVITATION_BATCH]: ({ commit, state, getters }, payload) => {
    return axios({
      url: API_NODE_BASE_URL + EVENTS_DOWNLOAD_INVITATION_BATCH_URL,
      method: "POST",
      data: payload,
      headers: {
        'Authorization': 'Bearer ' + getters.getUserAccessToken
      }
    })
  },
  [EVENTS_GET_BOOKING_FORM_DATA]: ({ commit, state, getters }, payload) => {
    return axios({
      url: API_BASE_URL + EVENTS_GET_BOOKING_FORM_DATA_URL,
      method: 'POST',
      data: payload,
      headers: {
        'Authorization': 'Bearer ' + getters.getUserAccessToken
      }
    })
  },
  [EVENTS_DELETE_EVENT_TICKET]: ({ commit, state, getters }, payload) => {
    return axios({
      url: API_BASE_URL + EVENTS_DELETE_EVENT_TICKET_URL,
      method: 'POST',
      data: payload,
      headers: {
        'Authorization': 'Bearer ' + getters.getUserAccessToken
      }
    })
  },
  [EVENTS_RESEND_TICKET_SMS]: ({ commit, state, getters }, payload) => {
    return axios({
      url: API_BASE_URL + EVENTS_RESEND_TICKET_SMS_URL,
      method: 'POST',
      data: payload,
      headers: {
        'Authorization': 'Bearer ' + getters.getUserAccessToken
      }
    })
  },
  [EVENTS_DELETE_BOOKING]: ({ commit, state, getters }, payload) => {
    return axios({
      url: API_BASE_URL + EVENTS_DELETE_BOOKING_URL,
      method: 'POST',
      data: payload,
      headers: {
        'Authorization': 'Bearer ' + getters.getUserAccessToken
      }
    })
  }
}
export default {
  mutations,
  actions,
  getters,
  state
}